<template>
    <div v-if="isDesktop" class="menuleft" @mouseover="HoverOver" @mouseleave="HoverLeave">
        <div class="top">
            <a href="/admin/offers/create" class="nova_cenova_ponuka topmenu" id="v-step-6">
                <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 0.5C7.26522 0.5 7.51957 0.605357 7.70711 0.792893C7.89464 0.98043 8 1.23478 8 1.5V6.5H13C13.2652 6.5 13.5196 6.60536 13.7071 6.79289C13.8946 6.98043 14 7.23478 14 7.5C14 7.76522 13.8946 8.01957 13.7071 8.20711C13.5196 8.39464 13.2652 8.5 13 8.5H8V13.5C8 13.7652 7.89464 14.0196 7.70711 14.2071C7.51957 14.3946 7.26522 14.5 7 14.5C6.73478 14.5 6.48043 14.3946 6.29289 14.2071C6.10536 14.0196 6 13.7652 6 13.5V8.5H1C0.734784 8.5 0.48043 8.39464 0.292893 8.20711C0.105357 8.01957 0 7.76522 0 7.5C0 7.23478 0.105357 6.98043 0.292893 6.79289C0.48043 6.60536 0.734784 6.5 1 6.5H6V1.5C6 1.23478 6.10536 0.98043 6.29289 0.792893C6.48043 0.605357 6.73478 0.5 7 0.5Z"
                        fill="white"
                    />
                </svg>
                {{ $t("menu.text_4") }}
            </a>
            <span class="ai_offer_side" @click="openAiOffer">
                <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 1.5L10.6 6.4L15.5 8L10.6 9.6L9 14.5L7.4 9.6L2.5 8L7.4 6.4L9 1.5Z" fill="currentColor" />
                    <path
                        d="M14.75 12.25L15.4 14.1L17.25 14.75L15.4 15.4L14.75 17.25L14.1 15.4L12.25 14.75L14.1 14.1L14.75 12.25Z"
                        fill="currentColor"
                    />
                </svg>
                {{ $t("ai_offer.button_generate") }}
                <paid-modal-icon v-if="!aiAllowed" :openModal="paidModalOpen" @close="paidModalOpen = false" />
            </span>
            <menu-item
                v-for="item in normal_items"
                :key="item.title"
                :data="item"
                :active="active"
                :paid_type="paid_type"
            />
            <div class="premium_line">
            </div>
            <div id="v-step-8">
                <menu-item
                    v-for="item in premium_items.slice(0, 3)"
                    :key="item.title"
                    :data="item"
                    :active="active"
                    :paid_type="paid_type"
                />
            </div>
            <div id="v-step-9">
                <menu-item
                    v-for="item in premium_items.slice(3, 6)"
                    :key="item.title"
                    :data="item"
                    :active="active"
                    :paid_type="paid_type"
                />
            </div>
            <div v-if="data.is_admin || data.is_blog">
                <div class="admin_line">
                    <span>
                        {{ $t("menu.text_2") }}
                    </span>
                </div>
                <menu-item
                    v-for="item in admin_items_blog"
                    :key="item.title"
                    :data="item"
                    :active="active"
                    :paid_type="paid_type"
                    :is_blog="data.is_blog"
                />
            </div>
            <div class="settings_line">
                <span>
                    {{ $t("menu.text_3") }}
                </span>
            </div>
            <div id="v-step-10">
                <menu-item
                    v-for="item in setting_items"
                    :key="item.title"
                    :data="item"
                    :active="active"
                    :stepId="item.stepId"
                    :paid_type="paid_type"
                />
            </div>
            <a href="/admin/offers/create" class="nova_cenova_ponuka">
                <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 0.5C7.26522 0.5 7.51957 0.605357 7.70711 0.792893C7.89464 0.98043 8 1.23478 8 1.5V6.5H13C13.2652 6.5 13.5196 6.60536 13.7071 6.79289C13.8946 6.98043 14 7.23478 14 7.5C14 7.76522 13.8946 8.01957 13.7071 8.20711C13.5196 8.39464 13.2652 8.5 13 8.5H8V13.5C8 13.7652 7.89464 14.0196 7.70711 14.2071C7.51957 14.3946 7.26522 14.5 7 14.5C6.73478 14.5 6.48043 14.3946 6.29289 14.2071C6.10536 14.0196 6 13.7652 6 13.5V8.5H1C0.734784 8.5 0.48043 8.39464 0.292893 8.20711C0.105357 8.01957 0 7.76522 0 7.5C0 7.23478 0.105357 6.98043 0.292893 6.79289C0.48043 6.60536 0.734784 6.5 1 6.5H6V1.5C6 1.23478 6.10536 0.98043 6.29289 0.792893C6.48043 0.605357 6.73478 0.5 7 0.5Z"
                        fill="white"
                    />
                </svg>
                {{ $t("menu.text_4") }}
            </a>
            <a href="/admin/feedback" class="feedback">
                {{ $t("menu.text_5") }}
            </a>
        </div>
        <div class="bottom">
            <a href="/admin/changelog" class="change-log">
                {{ $t("menu.text_6") }} {{ json[0].version }}
            </a>
        </div>
    </div>
</template>

<script>
import MenuItem from "./components/MenuItem.vue";
import PaidModalIcon from "../../admin/vue_components/PaidModalIcon.vue";
import { EventBus } from "../../admin/offer/components/EventBus.js";
import json from "../../admin/changelog/changelog.json";
import menulisting from "./menulisting";
export default {
    components: { MenuItem, PaidModalIcon },
    props: ["data", "amiowner", "paid_type", "is_paid"],
    data() {
        return {
            paidModalOpen: false,
            json: json.changelogs.reverse(),
            active: "",
            hide: null,
            hover: false,
            normal_items: null,
            setting_items: null,
            premium_items: null,
            admin_items: null,
            isDesktop: window.innerWidth > 1100,
        };
    },
    created() {
        this.hide = true;
        if (this.hide) this.hover = true;
        this.normal_items = menulisting["normal_items"];
        this.setting_items = menulisting["setting_items"];
        this.premium_items = menulisting["premium_items"];
        this.admin_items = menulisting["admin_items"];

        const itemToUpdate = this.premium_items.find((item) => item.title === "menu.mojiPouzivatelia");
        if (itemToUpdate) {
            itemToUpdate.show = this.amiowner;
        }
    },
    methods: {
        // Free plan k AI ponukam pristup nema — rovnako ako v zozname ponuk dostane upsell.
        openAiOffer() {
            if (!this.aiAllowed) {
                this.paidModalOpen = true;
                return;
            }
            // AiOfferModal je v layoute na kazdej admin stranke.
            EventBus.$emit("open-ai-offer-modal");
        },
        HoverOver() {
            if ($(".menuleft").hasClass("hide")) {
                $(".menuleft").removeClass("hide");
            }
        },
        HoverLeave() {
            if (localStorage.getItem("menu")) {
                $(".menuleft").addClass("hide");
            }
        },
        checkWindowSize() {
            this.isDesktop = window.innerWidth > 1100;
        },
    },
    computed: {
        aiAllowed() {
            return Number(this.is_paid) === 1;
        },
        admin_items_blog() {
            if (this.data.is_blog && !this.data.is_admin) {
                return this.admin_items.filter((item) => item.title === "menu.blog");
            }
            return this.admin_items;
        },
    },
    mounted() {
        var currentLocation = window.location;
        const handleItems = (items) => {
            items.forEach((item) => {
                if (item.paths.includes(currentLocation.pathname)) {
                    this.active = item.title;
                }
                if (item.roll) {
                    localStorage.setItem("menu", "roll");
                    $(".menuleft, .pcoded-content").addClass("hide");
                } else {
                    localStorage.removeItem("menu");
                    $(".menuleft, .pcoded-content").removeClass("hide");
                }
            });
        };
        const itemGroups = [
            this.normal_items,
            this.setting_items,
            this.premium_items,
            this.admin_items_blog,
        ];
        itemGroups.forEach(handleItems);
        window.addEventListener('resize', this.checkWindowSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkWindowSize);
    },
};
</script>

<style lang="scss" scoped>
.menuleft {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: 0.5s all;
    position: fixed;
    width: 300px;
    height: calc(100% - 90px);
    min-height: calc(100vh - 70px);
    margin-top: 90px;
    left: 0;
    top: 0;
    background: linear-gradient(0deg, #212541, #212541), #ffffff;
    z-index: 1027;
    @media only screen and (max-width: 1100px) {
        display: none;
    }
    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: linear-gradient(0deg, #212541, #212541), #ffffff;
    }
    &::-webkit-scrollbar-thumb {
        background: rgb(110, 110, 110);
    }
    &::-webkit-scrollbar-thumb:hover {
        background: rgb(134, 134, 134);
    }
    &.hide {
        width: 70px;
        .premium_line span,
        .admin_line span,
        .settings_line span {
            opacity: 0;
        }
        .bottom .change-log,
        .settings,
        .feedback,
        .nova_cenova_ponuka,
        .ai_offer_side {
            display: none;
        }
        @media only screen and (max-width: 830px) {
            width: 0px;
        }
    }
    overflow: scroll;
    .bottom {
        padding-bottom: 30px;
        .change-log {
            transition: 0.5s all;
            width: 100%;
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 20px;
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #2ed8b6;
        }
    }
    .settings {
        transition: 0.5s all;
        margin: 14px auto 20px auto;
        width: 239px;
        height: 55px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        box-sizing: border-box;
        border-radius: 6px;
        text-decoration: none;

        display: flex;
        align-items: center;
        justify-content: center;

        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: #ffffff;
        cursor: pointer;
        svg {
            margin-right: 10px;
        }
        margin-bottom: 20px;
    }
    .ai_offer_side {
        transition: 0.5s all;
        margin: 0 auto 10px auto;
        width: 90%;
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #ffffff;
        cursor: pointer;
        user-select: none;
        white-space: nowrap;
        svg {
            color: #2ed8b6;
            flex: none;
        }
        &:hover {
            background: rgba(255, 255, 255, 0.06);
            border-color: rgba(255, 255, 255, 0.4);
        }
    }
    .nova_cenova_ponuka {
        transition: 0.5s all;
        margin: 0 auto;
        width: 239px;
        height: 55px;
        background: #2ed8b6;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #ffffff;
        cursor: pointer;
        text-decoration: none;
        margin-top: 40px;
        svg {
            margin-right: 10px;
        }
        &.topmenu {
            height: 45px;
            margin-bottom: 10px;
            margin-top: 20px;
            width: 90%;
        }
    }
    .feedback {
        margin: 10px 0px;
        width: 100%;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        text-decoration: underline;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #bdbdbd;
    }
    .premium_line {
        margin: 27px 0;
        position: relative;
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.3);
        span {
            transition: 0.5s all;
            position: absolute;
            left: 30px;
            top: -10px;
            width: 91px;
            height: 20px;
            background: #fbbf24;
            border-radius: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 9px;
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            letter-spacing: 0.12em;
            text-transform: uppercase;
            color: #ffffff;
            svg {
                margin-right: 5px;
            }
        }
    }
    .settings_line {
        margin: 27px 0;
        position: relative;
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.3);
        span {
            transition: 0.5s all;
            position: absolute;
            left: 30px;
            top: -10px;
            width: 91px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(0deg, #212541, #212541), #ffffff;
            padding: 0 9px;
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            letter-spacing: 0.12em;
            text-transform: uppercase;
            color: #ffffff;
        }
    }
    .admin_line {
        margin: 27px 0;
        position: relative;
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.3);
        span {
            transition: 0.5s all;
            position: absolute;
            left: 30px;
            top: -10px;
            width: 91px;
            height: 20px;
            background: #4338ca;
            border-radius: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 9px;
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            letter-spacing: 0.12em;
            text-transform: uppercase;
            color: #ffffff;
        }
    }
}
</style>